export default "__VITE_ASSET__DsFrNixx__"